import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, from, of } from 'rxjs';
import { map, exhaustMap, catchError } from 'rxjs/operators';
import { DashboardService } from '../../features/services/dashboard.service';
import { getPanelistPoints } from '../actions/features.actions';

@Injectable()
export class FeaturesEffects {
  private actions$ = inject(Actions);
  private dashboardService = inject(DashboardService);

  getPanelistPoints$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getPanelistPoints.loadPanelistPoints),
      exhaustMap(() =>
        this.dashboardService.getPanelistPoints().pipe(
          map((data) => getPanelistPoints.loadPanelistPoints({ status: 'success', data })),
          catchError((error) =>
            of(getPanelistPoints.loadPanelistPoints({ status: 'error', error }))
          )
        )
      )
    )
  );

}